import 'v-calendar/dist/style.css';
import 'material-icons/iconfont/material-icons.css';
import '@fontsource/roboto/latin.css';
import '@/app/styles/app.css';
import App from '@/App.vue';
import router from '@/routes';
import i18n from '@/app/locales/locale';
import OktaVue from '@okta/okta-vue';
import { createPinia } from 'pinia';
import { DatePicker } from 'v-calendar';
import { createApp, App as VueApp } from 'vue';
import { oktaAuth } from '@/app/shared/okta/auth';
import { Can, abilitiesPlugin } from '@casl/vue';
import { ability } from '@/app/shared/services/ability-service';
import { useAuthStore } from './app/shared/stores/auth-store';

const mountApp = (app: VueApp<Element>) => {
  app.config.globalProperties.$appName = 'Attribute Toolbox';

  app.use(createPinia());

  async function initializeAuth() {
    const authStore = useAuthStore();

    try {
      const authMethod = await authStore.getLoginProfile();
      authStore.authMethod = authMethod;
    } catch (error) {
      authStore.authMethod = 'form';
    }
  }

  async function initializeApp() {
    await initializeAuth();
  }

  initializeApp().then(() => {
    app
      .use(router)
      .use(i18n)
      .use(OktaVue, {
        oktaAuth,
      })
      .use(abilitiesPlugin, ability, {
        useGlobalProperties: true,
      })
      .component('DatePicker', DatePicker)
      .component(Can.name, Can)
      .mount('#app');
  });
};

const application = createApp(App);
mountApp(application);
